import React, { useMemo, useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { Formik, Form } from 'formik';
import {
    Card, CardContent, Typography, Grid, Button, Box, TextField, Dialog, DialogContent, DialogTitle,DialogActions, IconButton, FormControl, Tooltip,
    InputLabel, Select, MenuItem,FormControlLabel,Radio,RadioGroup,
    OutlinedInput, InputAdornment, FormHelperText,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import Verification from './Verification';
import config from '../../AppConfig';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import swal from "sweetalert";
import * as Yup from 'yup';
import InputMask from 'react-input-mask';
import AuthUser from "../../Components/Auth/AuthUser";
import Freez from '../../Components/Loader/Loader';
import Backdrop from '@mui/material/Backdrop';
import { fetchData, postData } from '../../redux/apiSlice';
import { useDispatch } from 'react-redux';
import { parse, isBefore, subYears } from 'date-fns';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import dayjs from 'dayjs';
import Header from '../../views/Web/FundingShot/Header';
import Footer from '../../views/Web/FundingShot/Footer';
import step1 from '../../assets/images/step1.png';
import verification from '../../assets/images/verification.png';
import report from '../../assets/images/report.png';
import Chat from "../../Components/CreditSnapshot/Chat";
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TermsAndConditions from '../../views/FooterPages/TermsAndConditions';
import Stepper from './Stepper';
import TextareaAutosize from '@mui/base/TextareaAutosize';
import closeRound from '../../assets/images/closeRound.png';
import VerifyIdentity from './VerifyIdentity';
import AuthenticationIdentity from './AuthenticationIdentity';
let chatSessionId = null;
const today = dayjs();
let minDate = dayjs(today.subtract(110, 'year').toDate());
let maxDate = dayjs(today.subtract(18, 'year').toDate());

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
let mobile = "";
let ssn = "";
const formatDate = (dateString) => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
    });
    return formattedDate;
};
function EnrollStep1(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const inputRef1 = useRef();
    const [fullWidth, setFullWidth] = React.useState(true);
    const [maxWidth, setMaxWidth] = React.useState('sm');
    const isMobile = useMediaQuery('(max-width:600px)');
    const [aid, setAID] = useState(localStorage.getItem("SnapShot_aid"));
    const [open, setOpen] = React.useState(false);
    const [errormsg, setErrorMsg] = useState('');
    const [errorRes, setErrorMsgResponse] = useState('');
    const [enrolledStatus, setEnrolledStatus] = useState(0);
    const [states, setStates] = useState([]);
    const [isDateValid, setDateValid] = useState(true);
     const [open4, setOpen4] = useState(false);
    const [lessthanErrorMsg, setLessthanErrorMsg] = useState("");
    const [isValidFormat, setIsValidFormat] = useState(true);
    const [dateFormatErrorMsg, setDateFormatErrorMsg] = useState("");
    const [showPassword, setShowPassword] = React.useState(false);
    const [Dtoken, setDtoken] = useState();
    const [rtoken, setRtoken] = useState();
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(true);
    const [startJourneyOpen, setStartJourneyOpen] = useState(false);
    const [paToken, setpaToken] = useState();
    const [userid, setUserId] = useState();
    const [chatEnable, setChatEnable] = React.useState(false);
    const [emailEnable, setEmailEnable] = useState(false);
    const [companyObj, setCompanyObj] = React.useState(false);
    const [creditSnapshotObj, setCreditSnapshotObj] = useState([]);
    const [messages, setMessages] = useState([]);
    const [assistYouFlag, setAssistYouFlag] = useState(false);
    const [emailChatopen, setEmailChatopen] = useState(false);
    const [openIframe, setOpenIframe] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const [chatEmail, setChatEmail] = useState(localStorage.getItem('chatbot_email') != undefined ?  localStorage.getItem('chatbot_email') : null);
    const [chatfirstName, setFirstName] = useState(localStorage.getItem('SnapShot_firstName') != undefined ?  localStorage.getItem('SnapShot_firstName') : null);
    const [openEmail, setOpenEmail] = React.useState(false);
    const [formValues, setFormValues] = useState({});
    const [type, setType] =useState("");
   const [resendButtonDisable, setResendButtonDisable] = React.useState(false);
    const [resendCounter, setResendCounter] = React.useState(0);
    const [buttonText, setButtonText] = useState('Resend Link');
    const [popupType, setPopupType] = useState("funding");
        const handleClickOpenEmail = () => {
            setOpenEmail(true);
        };

        const handleCloseEmail = () => {
            setOpenEmail(false);
        };

    
    
    //loader function and variable start
    const [freez, setFreez] = React.useState(false);
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const { http, getToken } = AuthUser();
    const openEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setIsMinimized(true);
        setEmailChatopen(true);
    }
    const closeEmailChatPopup = () => {
        setStartJourneyOpen(false);
        setEmailChatopen(false);
    }

    const handleOpenCalendar = () => {
        const updatedUrl = creditSnapshotObj.funding_shot.meeting_link;
        window.open(updatedUrl, '_blank');
    }
    
    const openChatPopup = (e) => {
        setIsChatOpen(true);
        var sessionMessagesObj;
        if (localStorage.getItem("sessionMessages") != undefined) {
            sessionMessagesObj = localStorage.getItem("sessionMessages");
        }
        e.preventDefault();
        const element = document.getElementById("chatbotDiv");
        element.style.display = "block";
        setIsMinimized(!isMinimized);

        setStartJourneyOpen(false);
        chatSessionId = localStorage.getItem('chatSessionId');
        if (chatSessionId != null) {
            const sessionMessage1 = localStorage.getItem("sessionMessages");
            if (sessionMessage1) {
                const parsedMessages = JSON.parse(sessionMessage1);
                setMessages(parsedMessages);
            }

            setAssistYouFlag(true);
        } else {
            const Fname = localStorage.getItem('Main_firstName')?.trim() ? localStorage.getItem('Main_firstName') : 'Friend';
            if (sessionMessagesObj > 1) {
                setMessages(sessionMessagesObj);
            }
            if (!assistYouFlag) {
                setAssistYouFlag(true);
            }
        }

    }

    const toggleDrawer4 = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return;
        }
        setOpen4(open);
    };
    const changeOpenChatPopupValue = (value) => {
        setIsMinimized(value);
    }

    const handleIFrame = () => {
        setOpenIframe(true);
    }

    const handleCloseDialog = () => {
        setOpenIframe(false);
    }

    const handleClickOpen = () => {
        setPopupType("funding");
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const fetchState = () => {
        http.get("/fetchStates").then((res) => {
            setStates(res.data.data);
        });
    }

    useEffect(() => {
        fetchState();
    }, [])
    //fetch city and state from zipCode
    const fetchLocationInfo = async (zipcode, setFieldValue) => {
        const apiUrl = "/zipcode/" + zipcode;
        setFieldValue('city', '');
        setFieldValue('state', '');
        if (zipcode.length == 5) {
            setFieldValue('city', '...');
            setFieldValue('state', '...');
            handleFreezStart();
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res.success) {
                setFieldValue('city', res.data.places[0]['place name']);
                setFieldValue('state', res.data.places[0]['state abbreviation']);
                handleFreezStop();
            }
            else {
                setFieldValue('city', '');
                setFieldValue('state', '');
                handleFreezStop();
            }
        }
    };
    const validationSchema = Yup.object().shape({
        firstName: Yup.string()
            .max(25,'First Name must be of 25 characters')
            .matches(
                /^(?=[-0-9A-Za-z.#'\s]*$)/,
                'Please enter a valid First Name'
            )
            .required('First Name is required'),
        lastName: Yup.string()
            .max(25,'Last Name must be of 25 characters')
            .matches(
                /^(?=[-0-9A-Za-z.#'\s]*$)/,
                'Please enter a valid Last Name'
            )
            .required('Last Name is required'),
        email: Yup.string()
            //   .email('Please enter a valid email address') 
            .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
            .required('Email is required'),
        mobileNumber: Yup.string()
            .min(14, 'Phone Number must be exactly 10 digits!')
            .max(14, 'Phone Number must be of maximum 10 digits!')
            .required('Phone Number is required'),
        streetAddress: Yup.string()
            .min(1, 'Too Short!')
            .max(60, 'Street Address must be of maximum 60 characters')
            .matches(
                /^(?=[A-z0-9\-\. ]*$)/,
                'Please enter a valid Street Adress'
            )
            .required('Street Address is required'),
        streetAddress2: Yup.string()
            .min(1, 'Too Short!')
            .max(60, 'Street Address 2 must be of maximum 60 characters')
            .matches(
                /^(?=[A-z0-9\-\. ]*$)/,
                'Please enter a valid Street Adress'
            ),
        city: Yup.string()
            .max(30,'City must be of maximum 30 characters')
            .required('City is required'),

        state: Yup.string()
            .required('Please select State'),

        zipCode: Yup.string()
            .min(5, 'ZipCode must be of 5-10 digits!')
            .max(10, 'ZipCode must be of maximum 10 digits!')

            .required('Zipcode is required'),
        dateOfBirth: Yup.string()
            .required('Please enter Date of Birth'),
        password: Yup.string()
            .min(8, 'Password must be at least 8 characters')
            .matches(/^[^\+=]*$/, "The password contains invalid characters")
            .required('Password is required'),
        socialSecurityNumber: Yup.string()
            .min(11, 'Social Security Number must be exactly 9 digits!')
            .max(11, 'Social Security Number must be of maximum 9 digits!')
            .required('Social Security Number is required'),

    })
    const handleDateChange = (event) => {
        const { value } = event.target;
        // setInputDate(value);

        //check date format
        const regexPattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
        const checkformat = regexPattern.test(value);
        if (checkformat) {

            const [month, day, year] = value.split('/');
            const parsedDate = new Date(`${year}-${month}-${day}`);

            // Check if the parsed date is valid
            const isValidDate = !isNaN(parsedDate) && parsedDate.toISOString().slice(0, 10) === `${year}-${month}-${day}`;
            setIsValidFormat(isValidDate);
            if (!isValidDate) {
                setDateFormatErrorMsg("The birth date must be formatted as MM/DD/YYYY");
                return;
            }

        } else {
            setIsValidFormat(false);
            setDateFormatErrorMsg("The birth date must be formatted as MM/DD/YYYY");
            return;
        }
        //check less than 18 years old
        const inputDateParsed = parse(value, 'MM/dd/yyyy', new Date());
        const eighteenYearsAgo = subYears(new Date(), 18);
        const isValid = isBefore(inputDateParsed, eighteenYearsAgo);

        setDateValid(isValid);
        if (!isValid) {
            setLessthanErrorMsg("You must be at least 18 to be a member");
        } else {
            setLessthanErrorMsg("");
        }
    };

    const loginLink = () => {
        navigate('/fundingSnapshotlogin');
    }

    const SnapShotErollStep1 = (method) => {
        setType(method);
        console.log( formValues.firstName);
        mobile = formValues.mobileNumber.replace(/[^0-9]/g, '');
        ssn = formValues.socialSecurityNumber.replace(/[^0-9]/g, '');
        handleFreezStart();
        http.post("/enrollFundingSnapshotMember", {
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            email: formValues.email,
            password: formValues.password,
            source: "default",
            aid: aid,
            streetAddress1: formValues.streetAddress,
            streetAddress2: formValues.StreetAddress2,
            city: formValues.city,
            state: formValues.state,
            mobile: mobile,
            dob: formatDate(formValues.dateOfBirth),
            ssn: ssn,
            zip: formValues.zipCode,
            type: method,
        })
            .then((res) => {
                handleFreezStop();
                if (res.data.success === true) {
                    
                    setDtoken(res.data.data.dtoken)
                    setRtoken(res.data.data.rtoken)
                    setUserId(res.data.data.userId)
                    setpaToken(res.data.data.paToken)
                    localStorage.setItem('Dtoken', res.data.data.dtoken);
                    localStorage.setItem('rtoken', res.data.data.rtoken);
                    localStorage.setItem('paToken', res.data.data.paToken);
                    localStorage.setItem('UserId', res.data.data.userId);
                    localStorage.setItem("smfaToken", res.data.data.smfaToken);
                    localStorage.setItem("utoken", res.data.data.utoken);
                    localStorage.setItem('SnapShot_firstName', formValues.firstName);
                    localStorage.setItem('SnapShot_lastName', formValues.lastName);
                    localStorage.setItem('SnapShot_email', formValues.email);
                    localStorage.setItem('SnapShot_password', formValues.password);
                    localStorage.setItem('SnapShot_aid', aid);
                    localStorage.setItem('city', formValues.city);
                    localStorage.setItem('SnapShot_state', formValues.state);
                    localStorage.setItem('mobile', mobile);
                    localStorage.setItem('dob', formatDate(formValues.dateOfBirth));
                    localStorage.setItem('ssn', ssn);
                    localStorage.setItem('zip', formValues.zipCode);
                    localStorage.setItem('streetAddress', formValues.streetAddress);
                    localStorage.setItem('streetAddress1', formValues.StreetAddress2);
                    setOpen(true);
                    setOpenEmail(false);
                } else {
                    if (res.data.success === false) {
                        if (res.data.data.enrolledStatus == true) {
                            setEnrolledStatus(1);
                        }
                        handleFreezStop();
                        setErrorMsgResponse(res.data.data.errorByStichCredit)
                        setOpenEmail(false);
                    }
                    handleFreezStop();
                }
            })
            .catch((error) => {
                handleFreezStop();
                  setOpenEmail(false);
                swal({
                    title: "Failed",
                    text: error.message,
                    icon: "error",
                    button: "Ok",
                })
            });
    }
  

    const getCreditSnapshotDetails = (value) => {
        setCompanyObj(value);
        setChatEnable(value.funding_shot.enable_chat_support == 1 ? true : false);
        setEmailEnable(value.funding_shot.enable_email_support == 1 ? true : false);
        localStorage.setItem('SnapShot_chat_support', value.funding_shot.enable_chat_support == 1 ? true : false);
        localStorage.setItem('SnapShot_email_support', value.funding_shot.enable_email_support == 1 ? true : false);
        setCreditSnapshotObj(value);
    }
    const sendEmailChatSchema = Yup.object().shape({
        subject: Yup.string()
            .min(2, 'Too Short!')
            .required('Please enter subject'),
        description : Yup.string()
            .min(2, 'Too Short!')
            .required('Please enter Description'),
        email: Yup.string()
        //   .email('Please enter a valid email address') 
        .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
            .required('Please enter your email address'),
    });

     const Verification = () => {
            handleFreezStart();
            http.post("/enrollFundingSnapshotMember", {
                step:"VerifyPopup",
                aid: localStorage.getItem('SnapShot_aid'),
                userId: localStorage.getItem('UserId'),
                streetAddress1: localStorage.getItem('streetAddress'),
                streetAddress2: localStorage.getItem('streetAddress1'),
                city: localStorage.getItem('city'),
                state: localStorage.getItem('SnapShot_state'),
                mobile: localStorage.getItem('mobile'),
                dob: localStorage.getItem('dob'),
                ssn: localStorage.getItem('ssn'),
                zip: localStorage.getItem('zip'),
                firstName: localStorage.getItem('SnapShot_firstName'),
                lastName: localStorage.getItem('SnapShot_lastName'),
                email: localStorage.getItem('SnapShot_email'),
                password: localStorage.getItem('SnapShot_password'),
                source: "default",
                dtoken: localStorage.getItem('Dtoken'),
                utoken: localStorage.getItem('utoken'),
                smfaToken: localStorage.getItem('smfaToken'),
                url: config.BASE_URL,
            })
                .then((res) => {
                    handleFreezStop();
                    if (res.data.success === true) {
                        localStorage.setItem("ScoreData", JSON.stringify(res.data.data));
                        // Get the base URL
                        // Append "/score" to the base URL
                        const updatedUrl = config.BASE_URL + `ScoreReport/` + res.data.data.userId;
                        // Navigate to the updated URL
                        window.location.href = updatedUrl;
                    } else {
                        if (res.data.data.step === "VerifyPopup") {
                            // setButtonText("Resend Link");
                            // setResendButtonDisable(false);
                            // setSentotp(res.data.data.code);
                            // handleOpenDialog();
                            alert("Oops! Encountered some error. Please try again later. \n**" + res.data.data.errorByStichCredit);
                        } else {
                            handleFreezStop();
                            swal({
                                title: "Failed",
                                text: "Oops! Encountered some error. Please try again later. \n**" + res.data.data.errorByStichCredit,
                                icon: "error",
                                button: "Ok",
                            });
                        }
                    }
                })
                .catch((error) => {
                    handleFreezStop();
                    swal({
                        title: "Failed",
                        text: error.message,
                        icon: "error",
                        button: "Ok",
                    })
                });
        }
    
         const resendOtp = () => {
            setResendButtonDisable(true);
            setButtonText("Processing");
            const counter = resendCounter;
            setResendCounter(counter);
            http.post("/enrollFundingSnapshotMember", {
                aid: localStorage.getItem('SnapShot_aid'),
                userId: localStorage.getItem('UserId'),
                streetAddress1: localStorage.getItem('streetAddress'),
                streetAddress2: localStorage.getItem('streetAddress1'),
                city: localStorage.getItem('city'),
                state: localStorage.getItem('SnapShot_state'),
                mobile: localStorage.getItem('mobile'),
                dob: localStorage.getItem('dob'),
                ssn: localStorage.getItem('ssn'),
                zip: localStorage.getItem('zip'),
                firstName: localStorage.getItem('SnapShot_firstName'),
                lastName: localStorage.getItem('SnapShot_lastName'),
                email: localStorage.getItem('SnapShot_email'),
                password: localStorage.getItem('SnapShot_password'),
                counter: counter,
            })
                .then((res) => {
                    if (res.data.success === true) {
                        localStorage.setItem('Dtoken', res.data.data.dtoken);
                        localStorage.setItem('rtoken', res.data.data.rtoken);
                        localStorage.setItem('paToken', res.data.data.paToken);
                        localStorage.setItem('UserId', res.data.data.userId);
                        localStorage.setItem("smfaToken", res.data.data.smfaToken);
                        localStorage.setItem("utoken", res.data.data.utoken);
                        alert("Link Resent Successfully");
                    } else {
                        alert("Link Resent Failed");
                    }
                    setButtonText("Resend Link");
                    setResendButtonDisable(false);
                })
                .catch((error) => {
                    setButtonText("Resend Link");
                    setResendButtonDisable(false);
                    handleFreezStop();
                    swal({
                        title: "Failed",
                        text: error.message,
                        icon: "error",
                        button: "Ok",
                    })
                });
            }
    return (
        <>
            <Header aid={aid} logoName={'creditSnapShot'} onValueChange={getCreditSnapshotDetails} />
            <Stepper value={1}/>
           
            <Box sx={{mt:3}}>
                <Card sx={{
                    // borderRadius: isMobile ? "0px" : "0px 0 0 140px", // Rounded on the left only
                    boxShadow: 0,
                    backgroundColor:"#edededa1",
                    paddingLeft: isMobile ? 2 : 4, paddingRight: isMobile ? 2 : 4 ,
                   
                    // minHeight: isMobile ? "auto" : 300,
                    // maxHeight: isMobile ? "auto" : 700
                }}>

                    <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 3} sx={{ width: "100%", mt:isMobile?1:2,mb:isMobile?1:3 }}>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" mb={1}>
                                <Typography variant={isMobile ? 'body1' : 'h5'} fontWeight="bold" color="#0F31AC" textAlign="center">
                                    Great, Let’s Check Your Eligibility.
                                </Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <img
                                    src={require("../../assets/images/FunEnrollFirsts.png")} // update path
                                    alt="Business meeting"
                                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                                />
                            </Grid>
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                <Typography variant={isMobile ? 'body1' : 'h6'} textAlign="center" fontWeight="bold" gutterBottom>
                                    Get Started With A Completely FREE Funding Eligibility Report. ​</Typography>
                            </Grid>
                            {/* <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center" >
                                <Typography fontWeight="bold" fontSize={isMobile ? '0.7rem' : '1rem'} textAlign="center" gutterBottom>
                                    Yes, That Is Right, Your Credit Summary Is Completely <span style={{ color: "#33A218", fontSize: isMobile ? "0.9rem" : '1.2rem' }}> FREE.​</span>
                                </Typography>
                            </Grid> */}
                            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                <Typography variant='body1' fontWeight="bold" gutterBottom
                                    sx={{ color: "#33A218" }}>
                                    NO Credit Card Required.​​ </Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} justifyContent="center">
                                <Typography fontWeight="bold" textAlign="center" gutterBottom>
                                    Checking Your Credit Will NOT Harm Your Score​​​ </Typography>
                            </Grid>
                            <Formik
                                initialValues={{
                                    firstName: '',
                                    lastName: '',
                                    email: '',
                                    password: '',
                                    mobileNumber: '',
                                    streetAddress: '',
                                    streetAddress2: '',
                                    city: '',
                                    state: '',
                                    zipCode: '',
                                    dateOfBirth: '',
                                    socialSecurityNumber: '',

                                }}
                                validationSchema={validationSchema}
                                onSubmit={(values, { setSubmitting }) => {
                                    setFormValues(values);
                                    // setSubmitting(false);
                                     console.log("values12356", formValues);
                                    handleClickOpenEmail();
                                    // this is used on next button 
                                    // SnapShotErollStep1(values); 
                                }}
                            >
                                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                                    <Form>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>First Name*</InputLabel>
                                                    <OutlinedInput
                                                        id="firstName"
                                                        name="firstName"
                                                        autoComplete="firstName"
                                                        label="First Name"
                                                        type="text"
                                                        fullWidth
                                                        size="small"
                                                        margin="dense"
                                                        error={touched.firstName && !!errors.firstName}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.firstName && !errors.firstName ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.firstName && errors.firstName ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        value={values.firstName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.firstName && errors.firstName}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>Last Name*</InputLabel>
                                                    <OutlinedInput
                                                        id="lastName"
                                                        name="lastName"
                                                        label="Last Name*"
                                                        autoComplete="lastName"
                                                        error={touched.lastName && !!errors.lastName}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.lastName && !errors.lastName ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.lastName && errors.lastName ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        value={values.lastName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.lastName && errors.lastName}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>Email*</InputLabel>
                                                    <OutlinedInput
                                                        id="email"
                                                        name="email"
                                                        label="Email*"
                                                        autoComplete="emails"
                                                        error={touched.email && !!errors.email}
                                                        helperText={touched.email && errors.email}
                                                        defaultValue={values.email}
                                                        onChange={(e) => {
                                                            // checkUsaTLD(e.target.value);   
                                                            handleChange('email');
                                                            setFieldValue('email', e.target.value, true)
                                                        }}
                                                        onBlur={handleBlur}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.email && !errors.email ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.email && errors.email ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.email && errors.email && "Invalid email format."}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <InputMask
                                                    mask='(999) 999-9999'
                                                    maskChar={null}
                                                    name='mobileNumber'
                                                    fullWidth
                                                    margin="dense"
                                                    size="small"
                                                    id='mobileNumber'
                                                    autoComplete="mobileNumber"
                                                    error={touched.mobileNumber && !!errors.mobileNumber}
                                                    value={values.mobileNumber}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onKeyDown={() => setErrorMsg('')}
                                                >
                                                    {(inputProps) =>
                                                        <div>
                                                            <TextField
                                                                label="Phone Number*" variant="outlined"
                                                                {...inputProps}
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton edge="end">
                                                                                {touched.mobileNumber && !errors.mobileNumber ? (
                                                                                    <CheckIcon style={{ color: 'green' }} />
                                                                                ) : (
                                                                                    touched.mobileNumber && errors.mobileNumber ? (
                                                                                        <CloseIcon style={{ color: 'red' }} />
                                                                                    ) : null
                                                                                )}
                                                                            </IconButton>
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            />
                                                            <FormHelperText style={{ color: 'red' }}>
                                                                {touched.mobileNumber && errors.mobileNumber}
                                                            </FormHelperText>
                                                        </div>
                                                    }
                                                </InputMask>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl fullWidth>
                                                    <InputMask
                                                        mask='99/99/9999'
                                                        maskChar={null}
                                                        name="dateOfBirth"
                                                        id='dateOfBirth'
                                                        autoComplete="dateOfBirth"
                                                        value={values.dateOfBirth}
                                                        maxDate={maxDate}
                                                        minDate={minDate}
                                                        label="Date of Birth*"
                                                        size="small"
                                                        onChange={(e) => {
                                                            handleDateChange(e);
                                                            handleChange(e);
                                                        }}
                                                        onBlur={handleBlur}
                                                        onKeyDown={() => setErrorMsg('')}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        placeholder="MM/DD/YYYY"
                                                        error={touched.dateOfBirth && !!errors.dateOfBirth}
                                                    >
                                                        {(inputProps) =>
                                                            <div>
                                                                <TextField
                                                                    inputRef={inputRef1}
                                                                    label="Date of Birth*" variant="outlined"
                                                                    {...inputProps}
                                                                    InputProps={{
                                                                        endAdornment: (
                                                                            <InputAdornment position="end">
                                                                                <IconButton edge="end">
                                                                                    {touched.dateOfBirth && !errors.dateOfBirth && isValidFormat && isDateValid ? (
                                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                                    ) : (
                                                                                        (touched.dateOfBirth && errors.dateOfBirth || !isValidFormat || !isDateValid) ? (
                                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                                        ) : null
                                                                                    )}
                                                                                </IconButton>
                                                                            </InputAdornment>
                                                                        ),
                                                                    }}
                                                                />
                                                                <FormHelperText style={{ color: 'red' }}>
                                                                    {touched.dateOfBirth && errors.dateOfBirth}
                                                                </FormHelperText>
                                                            </div>
                                                        }
                                                    </InputMask>

                                                </FormControl>
                                                <FormHelperText sx={{ color: "#d32f2f" }}>{!isValidFormat ? dateFormatErrorMsg : !isDateValid ? lessthanErrorMsg : ''}</FormHelperText>

                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <InputMask
                                                    mask='999-99-9999'
                                                    maskChar={null}
                                                    placeholder="555-55-5555"
                                                    name='socialSecurityNumber'
                                                    id='socialSecurityNumber'
                                                    autoComplete="socialSecurityNumber"
                                                    error={touched.socialSecurityNumber && !!errors.socialSecurityNumber}
                                                    helperText={touched.socialSecurityNumber && errors.socialSecurityNumber}
                                                    value={values.socialSecurityNumber}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onKeyDown={() => setErrorMsg('')}
                                                    fullWidth
                                                    margin="dense"
                                                    size="small"

                                                >
                                                    {(inputProps) =>
                                                        <div>
                                                            <TextField
                                                                label="Social Security Number - Full*"
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="dense"
                                                                size="small"
                                                                InputProps={{
                                                                    endAdornment: (
                                                                        <InputAdornment position="end">
                                                                            <IconButton edge="end">
                                                                                {touched.socialSecurityNumber && !errors.socialSecurityNumber ? (
                                                                                    <CheckIcon style={{ color: 'green' }} />
                                                                                ) : (
                                                                                    touched.socialSecurityNumber && errors.socialSecurityNumber ? (
                                                                                        <CloseIcon style={{ color: 'red' }} />
                                                                                    ) : null
                                                                                )}
                                                                            </IconButton>
                                                                            <Tooltip
                                                                                placement='top'
                                                                                title="Your social security number is needed to confirm your identity and retrieve your credit report and score." arrow>
                                                                                <IconButton
                                                                                    edge="end"
                                                                                >
                                                                                    <img alt="#" src={require("../../assets/images/i_icon.png")} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </InputAdornment>
                                                                    ),
                                                                    ...inputProps,
                                                                }}
                                                            />
                                                            <FormHelperText style={{ color: 'red' }}>
                                                                {touched.socialSecurityNumber && errors.socialSecurityNumber}
                                                            </FormHelperText>
                                                        </div>
                                                    }
                                                </InputMask>
                                            </Grid>
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>Street Address*</InputLabel>
                                                    <OutlinedInput
                                                        id="streetAddress"
                                                        name="streetAddress"
                                                        label="streetAddress*"
                                                        error={touched.streetAddress && !!errors.streetAddress}
                                                        helperText={touched.streetAddress && errors.streetAddress}
                                                        value={values.streetAddress}
                                                        autoComplete="streetAddress"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onKeyDown={() => setErrorMsg('')}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.streetAddress && !errors.streetAddress ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.streetAddress && errors.streetAddress ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }

                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.streetAddress && errors.streetAddress}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                                <TextField
                                                    id="streetAddress2"
                                                    name="streetAddress2"
                                                    label="Street Address line 2 (Optional)"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="dense"
                                                    size="small"
                                                    autoComplete="streetAddress2"
                                                    error={touched.streetAddress2 && !!errors.streetAddress2}
                                                    helperText={touched.streetAddress2 && errors.streetAddress2}
                                                    value={values.streetAddress2}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onKeyDown={() => setErrorMsg('')}
                                                />
                                            </Grid>


                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <InputMask
                                                    mask='9999999999'
                                                    maskChar={null}
                                                    id="zipCode"
                                                    name="zipCode"
                                                    label="Zip Code*"
                                                    variant="outlined"
                                                    fullWidth
                                                    margin="dense"
                                                    size="small"
                                                    autoComplete="zipCode"
                                                    error={touched.zipCode && !!errors.zipCode}
                                                    helperText={touched.zipCode && errors.zipCode}
                                                    value={values.zipCode}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        fetchLocationInfo(e.target.value, setFieldValue);
                                                    }}
                                                    onKeyDown={() => setErrorMsg('')}
                                                    onBlur={handleBlur}
                                                >
                                                    {(inputProps) =>
                                                        <TextField
                                                            label="Zip Code*" variant="outlined"
                                                            {...inputProps}
                                                            InputProps={{
                                                                endAdornment: (
                                                                    <InputAdornment position="end">
                                                                        <IconButton edge="end">
                                                                            {touched.zipCode && !errors.zipCode ? (
                                                                                <CheckIcon style={{ color: 'green' }} />
                                                                            ) : (
                                                                                touched.zipCode && errors.zipCode ? (
                                                                                    <CloseIcon style={{ color: 'red' }} />
                                                                                ) : null
                                                                            )}
                                                                        </IconButton>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    }
                                                </InputMask>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>City*</InputLabel>
                                                    <OutlinedInput
                                                        id="city"
                                                        name="city"
                                                        label="city*"
                                                        autoComplete="city"
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.city && !errors.city ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.city && errors.city ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        error={touched.city && !!errors.city}
                                                        helperText={touched.city && errors.city}
                                                        value={values.city}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onKeyDown={() => setErrorMsg('')}
                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.city && errors.city}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>


                                        </Grid>

                                        <Grid container item lg={12} md={12} sm={12} xs={12} spacing={isMobile ? 0 : 2}>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl fullWidth margin="dense" size="small"
                                                    error={touched.state && errors.state ? errors.state : null} >
                                                    <InputLabel id="demo-multiple-name-label">State*</InputLabel>
                                                    <Select
                                                        fullWidth
                                                        labelId="demo-simple-select-label"
                                                        name="state"
                                                        autoComplete="state"
                                                        error={touched.state && !!errors.state}
                                                        helperText={touched.state && errors.state}
                                                        value={values.state}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        onClick={() => setErrorMsg('')}
                                                        id="state"
                                                        MenuProps={MenuProps}
                                                        input={<OutlinedInput label="State*" />}
                                                    >
                                                        {states.map((state, id) => {
                                                            return (
                                                                <MenuItem value={state.state_code}>{state.state_name}</MenuItem>
                                                            )
                                                        })}
                                                    </Select>
                                                    {touched.state && errors.state ? <FormHelperText style={{ color: 'red' }}>Please select State.</FormHelperText> : null}
                                                </FormControl>
                                            </Grid>
                                            <Grid item lg={6} md={6} sm={12} xs={12} >
                                                <FormControl variant="outlined" fullWidth
                                                    margin="dense" size="small">
                                                    <InputLabel>Password*</InputLabel>
                                                    <OutlinedInput
                                                        id="password"
                                                        name="password"
                                                        label="Password*"
                                                        autoComplete="password"
                                                        type={showPassword ? 'text' : 'password'}
                                                        error={touched.password && !!errors.password}
                                                        helperText={touched.password && errors.password}
                                                        defaultValue={values.password}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    edge="end"
                                                                >
                                                                    {touched.password && !errors.password ? (
                                                                        <CheckIcon style={{ color: 'green' }} />
                                                                    ) : (
                                                                        touched.password && errors.password ? (
                                                                            <CloseIcon style={{ color: 'red' }} />
                                                                        ) : null
                                                                    )}
                                                                </IconButton>
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? (
                                                                        <VisibilityOffIcon />
                                                                    ) : (
                                                                        <VisibilityIcon />
                                                                    )}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                    />
                                                    <FormHelperText style={{ color: 'red' }}>
                                                        {touched.password && errors.password}
                                                    </FormHelperText>
                                                </FormControl>
                                            </Grid>

                                        </Grid>
                                        {errorRes ? <>
                                            <Typography sx={{ color: "red" , whiteSpace: "pre-line" }} ><b>
                                                Error : -{enrolledStatus == 1 ? null : (<> Oops! Encountered some error. Please try again later. <br /> </>)}
                                                **{errorRes}  {enrolledStatus == 1 ? <><Button color="success" variant="contained" onClick={loginLink} >Login</Button></> : null}</b>
                                            </Typography>
                                        </>
                                            : null}

                                              <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}>
                                            <Grid item lg={5} md={5} sm={12} xs={12} sx={{marginRight: '-7%'}}>
                                            <Typography>By Clicking 'NEXT' I Agree To: </Typography>
                                            </Grid>
                                            <Grid item lg={7} md={7} sm={12} xs={12}>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                <Typography> (1) Be Contacted By <b>{companyName ? companyName : ''}</b> Email, Or By Phone / SMS Text</Typography>
                                                </Grid>
                                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                                    <Typography>
                                                    (2) The
                                                {/* &nbsp;<a href="#" onClick={toggleDrawer3(true)} style={{ cursor: "pointer" }}>Privacy Policy</a>
                                                <SwipeableDrawer
                                                    anchor={'bottom'}
                                                    open={open3}
                                                    onClose={toggleDrawer3(false)}
                                                    onOpen={toggleDrawer3(true)}
                                                >
                                                    <PrivacyPolicy closeVal={toggleDrawer3(false)} />
                                                </SwipeableDrawer>
                                                &nbsp;and&nbsp; */}
                                                <a href="#" onClick={toggleDrawer4(true)} style={{ cursor: "pointer" }}> Terms & Conditions</a>
                                                <SwipeableDrawer
                                                    anchor={'bottom'}
                                                    open={open4}
                                                    onClose={toggleDrawer4(false)}
                                                    onOpen={toggleDrawer4(true)}
                                                >
                                                    <TermsAndConditions closeVal={toggleDrawer4(false)} />
                                                </SwipeableDrawer>.
                                            </Typography>
                                                </Grid>
                                            </Grid>
                                                                                               
                                                                                                
                                        </Grid>
                                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={2}
                                            sx={{ display: "flex", justifyContent: "right" }}>
                                            <Button variant="contained" color="success" 
                                            id="step1NextButton"
                                            name="step1NextButton"
                                            onClick={handleSubmit} sx={{
                                                backgroundColor: "#3FAC19",
                                                fontWeight: 700,
                                                minWidth: "300px",
                                                minHeight: "40px",
                                                fontSize: "16px",
                                                borderRadius: "10px",
                                            }}>NEXT</Button>
                                        </Grid>
                                    </Form>
                                )}
                            </Formik>
                        </Grid>
                    </Grid>
                </Card>
                <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} sx={{
                    display: "flex",
                    justifyContent: isMobile ? "center" : "flex-end",
                    mt: isMobile ? 2 : 0,
                    mb: isMobile ? 2 : 3,
                    padding: 2
                }} >
                     {
                     chatEnable ? 
                    <Grid item>
                        <Button varient="outlined"
                            onClick={openChatPopup}
                            // disabled={isChatOpen}
                            startIcon={<img src={require("../../assets/images/chatforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none !important",
                                border: "1px solid #2E67BC",
                                minWidth: '250px', maxWidth: '300px',
                                color: "black",
                                alignItems: "center",
                                borderRadius: "6px",
                                fontWeight: "bold"// Prevents uppercase transformation
                            }}>Chat With Us Now</Button>
                    </Grid>
                     : ''
                    }
                    {
                        emailEnable ?
                    <Grid item >
                        <Button startIcon={<img src={require("../../assets/images/Emailforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            onClick={openEmailChatPopup}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC",
                                minWidth: '250px', maxWidth: '300px',
                                color: "black",
                                alignItems: "center",
                                borderRadius: "6px",
                                fontWeight: "bold" // Prevents uppercase transformation
                            }}>Email Us Now</Button>
                    </Grid>
                    : ''
                    } 

                    {creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.step2_link ? 
                    <Grid item >
                        <Button
                            onClick={handleIFrame}
                            startIcon={<img src={require("../../assets/images/playforbutton.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC", // Prevents uppercase transformation
                                minWidth: '250px', maxWidth: '300px',
                                alignItems: "center",
                                color: "black",
                                fontWeight: "bold",
                                borderRadius: "6px",
                            }}>Learn More About Us
                        </Button>
                    </Grid>
                     : ''
                     } 

                    <Grid item >
                        {
                            creditSnapshotObj && creditSnapshotObj.funding_shot && creditSnapshotObj.funding_shot.enable_meeting_link ? 
                            <Button
                            onClick={handleOpenCalendar}
                            startIcon={<img src={require("../../../src/assets/images/meeting.png")} alt="icon" style={{ width: 30, height: 30 }} />}
                            sx={{
                                textTransform: "none",
                                border: "1px solid #2E67BC", // Prevents uppercase transformation
                                minWidth: '250px', maxWidth: '300px',
                                alignItems: "center",
                                color: "black",
                                fontWeight: "bold",
                                borderRadius:"6px",
                            }}>Book A Meeting
                        </Button>
                        : ''
                        }
                        
                    </Grid>
                </Grid>
                <Box>
                    <Chat mEmail={chatEmail} firstName={chatfirstName} isMinimized={isMinimized} changeOpenChatPopupValue={changeOpenChatPopupValue} openEmailChatPopup={openEmailChatPopup} companyId={companyObj.company_master_id} source="snapshot" />
                </Box>
            </Box>
            <Dialog
                open={open}
               
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setOpen(false);
                    }
                }}
                disableEscapeKeyDown={true}
            >
                <Grid container item lg={12} md={12} sm={12} xs={12}>
                    <Grid item lg={6} md={6} sm={9} xs={9}>
                        <DialogTitle sx={{ m: 0, p: 2, fontWeight: "bold" }} id="customized-dialog-title" >
                            Verify Identity
                        </DialogTitle>
                    </Grid>
                    <Grid item lg={6} md={6} sm={3} xs={3}>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: "black"
                            })}
                        >
                            <HighlightOffIcon />
                        </IconButton>
                    </Grid>
                </Grid>


                <DialogContent>
                    <Grid>
                        <AuthenticationIdentity popupType={popupType} type={type} handleSubmitOtp={Verification} resendOtp={resendOtp}
                                            resendButtonDisable={resendButtonDisable} buttonText={buttonText}/>
                        {/* <Verification type={type} /> */}
                    </Grid>
                </DialogContent>
            </Dialog>

            <Formik
                initialValues={{
                subject: '',
                description : '',
                email : ''
                }}
                validationSchema={sendEmailChatSchema}
                onSubmit={async (values, { resetForm }) => {
                handleFreezStart();
                http.post("/sendChatEmail", {
                    email : values.email,
                    subject : values.subject,
                    description : values.description,
                    companyId : companyObj.company_master_id,
                    source : "snapshot"
                })
                .then((res) => {
                    if (res.data.success === true) {
                    swal({
                        title: "Success",
                        text: res.data.message,
                        icon: "success",
                        button: "Ok",
                    });
                    handleFreezStop();
                    }else{
                    // alert("something went wrong");
                    handleFreezStop();
                    }
                })
                closeEmailChatPopup();
                resetForm();
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Dialog
                    open={emailChatopen}
                    onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        // setDeleteOpen(false)
                    }
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                <DialogTitle id="alert-dialog-title">
                    {/* Delete Pid */}
                    <Grid container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent:"space-between"}}>
                    <Grid item lg={10} md={10} sm={10} xs={10}>
                        <Typography level="h5" sx={{textAlign:"center"}}>Send Us The Email</Typography>
                    </Grid>
                    <Grid item lg={2} md={2} sm={2} xs={2} sx={{textAlign:"right"}}>
                        <CloseIcon  onClick={closeEmailChatPopup}/>
                    </Grid>
                    </Grid>
                </DialogTitle>
                <DialogActions >
                <Grid container item lg={12} md={12} sm={12} xs={12} >
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                            id="outlined-start-adornment"
                            type="text"
                            label="From Email Address"
                            fullWidth
                            variant="outlined"
                            size="small"
                            margin="dense"
                            autoComplete="email"
                            value={values.email}
                            onChange={handleChange('email')}
                            onBlur={handleBlur('email')} 
                            InputLabelProps={{
                                shrink: Boolean(values.email), 
                            }}
                            />
                            {touched.email && errors.email ? <div className="error">{errors.email}</div> : null}
                        </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <TextField
                        id="outlined-start-adornment"
                        type="text"
                        label="Subject"
                        fullWidth
                        variant="outlined"
                        size="small"
                        margin='dense'
                        autoComplete='subject'
                        value={values.subject}
                        onChange={handleChange('subject')}
                        onBlur={handleBlur('subject')}
                        InputLabelProps={{
                            shrink: Boolean(values.subject)
                        }}
                        /> 
                        {touched.subject && errors.subject ? <div className='error'>{errors.subject}</div> : null}
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                        <TextareaAutosize
                            placeholder="Message"
                            type="text"
                            size="small"
                            fullWidth
                            name='description'
                            autoComplete='description'
                            id='description'
                            onChange={handleChange('description')}
                            onBlur={handleBlur('description')}
                            value={values.description}
                            maxRows={7}
                            minRows={4}
                            
                            style={{
                            width: '100%', // Ensures full width
                            // padding: '8px', // Optional for better spacing
                            boxSizing: 'border-box', // Ensures padding doesn't affect width
                        }}
                        />
                        {touched.description && errors.description ? <div className='error'>{errors.description}</div> : null}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent: "center", display: "flex"}}>
                    <Button variant="contained" sx={{ minWidth: 200 }} color="success" 
                        onClick={handleSubmit}
                        >
                        Send
                    </Button>
                    </Grid>
                </Grid>
                </DialogActions>
                </Dialog>
            )}
            </Formik>
            {/* phone and email functionality start here */}
            <Dialog
                open={openEmail}
                 onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseEmail();
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={fullWidth}
                maxWidth={maxWidth}
              
            >
                <DialogContent id="verifyIdentity">
                     <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} mt={1} mb={1}>  
                                    <Grid item lg={6} md={6} sm={6} xs={6}>
                                        <Typography fontWeight={"bold"} variant='h5'>Verify Identity</Typography>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xs={6} textAlign={"right"}>
                                        <IconButton onClick={handleCloseEmail}>
                                            <img src={closeRound} alt="close" />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                                <Grid container item lg={12} md={12} sm={12} xs={12} >
                                <VerifyIdentity SnapShotErollStep1={SnapShotErollStep1} />
                                </Grid>
                  
                </DialogContent>
            </Dialog>
            {/* phone and email functionality end here */}
            {/* Iframe Dialog Start */}
            <Dialog open={openIframe}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseDialog();
                    }
                }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}>
                <DialogTitle sx={{ bgcolor: "#F6FAFF" }}>
                    <Grid container item xs sx={{ justifyContent: "space-between" }}>
                        <Grid item xs>
                            <Typography level="h4" color="primary">Learn More About Us</Typography>
                        </Grid>
                        <Grid item xs sx={{ textAlign: "right" }}>
                            <IconButton
                                aria-label="close"
                                onClick={handleCloseDialog}
                                sx={{
                                    position: 'absolute',
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ justifyContent : "center" }}>
                        <iframe
                            width="560"
                            height="315"
                            src={creditSnapshotObj && creditSnapshotObj.funding_shot ? creditSnapshotObj.funding_shot.step2_link : ''}
                            title="Video Player"
                            // frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </Grid>
                </DialogContent>
                {/* </DialogActions> */}
            </Dialog>
            {/* Iframe Dialog End */}
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
            <Footer />
            {isChatOpen && (
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "2%",
                        right: "2%",
                        cursor: "pointer",
                    }}
                    onClick={openChatPopup}
                >
                    <img
                        src={require("../../assets/images/chatforbutton.png")}
                        alt="Chat Icon"
                        style={{
                        width: "70px",
                        height: "70px",
                        borderRadius: "50%",
                        boxShadow:
                            "0px 4px 8px rgba(0, 0, 0, 0.2), 0px 8px 16px rgba(0, 0, 0, 0.19)",
                        }}
                    />
                </Box>
            )}
        </>
    );
}





export default EnrollStep1;